import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyLink() {
    return (
        <div className="text-center text-xs text-gray-500">
            By continuing, you agree to our{' '}
            <Link 
                to="/privacy-policy" 
                className="text-indigo-600 hover:text-indigo-500 font-medium"
            >
                Privacy Policy
            </Link>
        </div>
    );
} 